export const enum RepeatingAction {
    allInFuture = 'all',
    selected = 'selected',
}
